import React from 'react';

import Slider from 'rc-slider';
import {UncontrolledTooltip} from 'reactstrap';
import PercentageInput from './PercentageInput';
import Toggle from './Toggle';

export default ({id, label, value, opened, enabled, locked, active, hasChildren, onBeforeChange, onChange, onAfterChange, onToggleLocked, onToggleOpened, tooltip}) => {
  let slider;
  let toggle;
  let ttOverlay;


  if(typeof value !== 'undefined'){
    slider = [
      (
        <div key={`${id}-slider`} className="slider">
          <Slider
            className={active ? 'active' : ''}
            value={value}
            disabled={!enabled}
            onChange={onChange}
            onBeforeChange={onBeforeChange}
            onAfterChange={onAfterChange}
          />
        </div>
      ),
      (
        <div key={`${id}-icons`} className="icons d-flex flex-row align-items-center">
          <PercentageInput value={value} onChange={onChange} disabled={!enabled || locked} />
          <Toggle onClick={onToggleLocked} opened={enabled && !locked} openedClass="control-spacer-left fa-lock-open-alt" closedClass="control-spacer-left fa-lock-alt" />
        </div>
      )
    ]
  }
  if(hasChildren){
    toggle = [
      (<Toggle key={`${id}-toggle`} opened={opened} openedClass="far fa-chevron-down" closedClass="far fa-chevron-right" onClick={onToggleOpened}/>)
   ];
  } else {
    toggle = [
      (<div key={`${id}-emptyToggle`}> </div>)
    ]
  }
  if(typeof tooltip !== 'undefined'){
    const id = "slideEnterLockHeader_tt";
    ttOverlay = <span className="control-spacer-left">
      <i className="fas fa-question-circle" id={id}/>
      <UncontrolledTooltip placement="top" target={id}>
        {tooltip}
      </UncontrolledTooltip>
    </span>;
  }
  let ttDisabled;
  if(!enabled){
    ttDisabled = (
      <span className="score-toggle">
        <UncontrolledTooltip placement="top" target={"scoreSets_disabled"}>
          This feature is not available for the selected accounts.
        </UncontrolledTooltip>
        <i className="fas fa-question-circle" id="scoreSets_disabled"/>
      </span>
    );
  }

  return (
    <div key={`${id}-slideLockHeader`} className="slide-lock slide-lock-header score-setting-container">
      <div className="title">
        {ttDisabled || toggle}<span className={`slide-label nowrap ${!!ttDisabled ? 'control-spacer-left' : ''}`}>{label}</span>{ttOverlay}
      </div>
      {slider}
    </div>
  );
}
